import { ReactNode, MouseEventHandler } from "react";
import { Link } from "react-router-dom";
import { areaLink, adminAreaLink } from "../utils/climbingAreaUtils";
import { ClimbingArea } from "../types"

export interface ClimbingAreaLinkProps {
    area: ClimbingArea;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
    onMouseDown?: MouseEventHandler<HTMLAnchorElement>;
}
export function ClimbingAreaLink({ area, onClick, onMouseDown }: ClimbingAreaLinkProps) {
    return (
        <Link to={areaLink(area)} key={area.areaId} onClick={onClick} onMouseDown={onMouseDown}>{area.name}</Link>
    );
}

export interface AdminAreaLinkProps {
    code: string;
    className?: string;
    children: ReactNode;
}
export function AdminAreaLink({ code, className, children }: AdminAreaLinkProps) {
    return (
        <Link to={adminAreaLink(code)} key={code} className={className}>{children}</Link>
    );
}
